module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x-skill-bar",
    class: {
      'red': _vm.red
    },
    attrs: {
      "data-x-element": "skill_bar",
      "data-x-params": '{percent:\'' + _vm.progress + '%\'' + '}'
    }
  }, [_c('div', {
    staticClass: "bar",
    style: ('width: ' + _vm.progress + '%;')
  }, [_c('div', {
    staticClass: "percent"
  }, [_vm._v(_vm._s(_vm.progress) + "%")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d7566f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Helpers/skillbar.vue
// module id = 45
// module chunks = 0